import { createContext } from 'react';
var MenuContext = createContext({
  inlineCollapsed: false
});
export default MenuContext;